import React,{useState} from "react";
import BackButton from "../../../../../components/common/backbutton/BackButton";
import Option from "../Option";
import NewCmpNameChange from "./NewCmpNameChange";
import OldCmpNameChange from './OldCmpNameChange'


const ComapanyNameChange = () => {
  const [turnOn, setTurnOn] = useState(true)  

  return (
    <div className="px-10 lg:!px-14">
        <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
         Company Name Change Form
        </p>
        {/* <tr className="flex justify-between my-4">
          <tr className=" flex flex-col md:flex-row gap-3 text-primary-red text-base font-bold sm:text-lg">
            <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
              <input type="radio" name="radio-btn" id="old"
                 onChange={()=> setTurnOn(true)}
               />
            </td>
            <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" name="radio-btn" id="new"
              onChange={()=> setTurnOn(false)}
              />
            </td>
          </tr>
          <p className="text-primary-red flex items-center">
            Firm No.
            <p className=" text-primary-blue"> 1234</p>
          </p>
        </tr> */}
        <Option setTurnOn={setTurnOn} turnOn={turnOn}/>
        <div className="flex my-3 justify-between">
          <p className="text-primary-blue font-Calistoga text-lg underline">
            1. Business Name & Other Details
          </p>
        </div>

        {
          turnOn ? 
          <OldCmpNameChange/>:
          <NewCmpNameChange/>
        }
          
    </div>
      
  );
};

export default ComapanyNameChange;
